export const FEET = '\u2032';
export const INCHES = '\u2033';
export const EXP_2 = '\u00B2';
export const FEET_IN_METER = 3.280839895;
export const SQUARE_FEET_IN_SQUARE_METER = FEET_IN_METER ** 2;
